var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-top"},[_c('div',{staticClass:"hero-top__wrapper"},[_c('img',{staticClass:"hero-top__background",attrs:{"src":_vm.backgroundImage,"alt":""}}),_c('div',{staticClass:"hero-top__limiter"},[_vm._t("hero-top-breadcrumbs"),_vm._t("hero-top-title"),_vm._t("hero-top-descriptions"),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }